import { Property } from './properties.model';

export const PROPERTY: Property[] = [
  new Property(0, 0, 0, null),
  new Property(1, 60, 2, null),
  new Property(2, 0, 0, null),
  new Property(3, 60, 4, null),
  new Property(4, 0, 0, null),
  new Property(5, 200, 0, null),
  new Property(6, 100, 6, null),
  new Property(7, 0, 0, null),
  new Property(8, 100, 6, null),
  new Property(9, 120, 8, null),
  new Property(10, 0, 0, null),
  new Property(11, 140, 10, null),
  new Property(12, 150, 0, null),
  new Property(13, 140, 10, null),
  new Property(14, 160, 12, null),
  new Property(15, 200, 0, null),
  new Property(16, 180, 14, null),
  new Property(17, 0, 0, null),
  new Property(18, 180, 14, null),
  new Property(19, 200, 16, null),
  new Property(20, 0, 0, null),
  new Property(21, 220, 18, null),
  new Property(22, 0, 0, null),
  new Property(23, 220, 18, null),
  new Property(24, 240, 20, null),
  new Property(25, 200, 0, null),
  new Property(26, 260, 22, null),
  new Property(27, 260, 22, null),
  new Property(28, 150, 0, null),
  new Property(29, 280, 24, null),
  new Property(30, 0, 0, null),
  new Property(31, 300, 26, null),
  new Property(32, 300, 26, null),
  new Property(33, 0, 0, null),
  new Property(34, 320, 28, null),
  new Property(35, 200, 0, null),
  new Property(36, 0, 0, null),
  new Property(37, 350, 35, null),
  new Property(38, 0, 0, null),
  new Property(39, 400, 50, null),
  new Property(40, 0, 0, null),
];



// WEBPACK FOOTER //
// /Users/philipeskins/Desktop/Epicodus/monopoly/src/app/Properties-data.ts